<template>
	<div style="width: 100%;">
		<PageHeader @back="goback" :content="'访员配置'" />
		<div class="interviewerBox">
			<div class="interviewer-set">
				<!-- <el-button size="medium" type="primary" @click="goSrtting">访员管理</el-button> -->
				<!-- <el-button size="medium" type="primary" @click="goDialConfiguration">坐席绑定</el-button> -->
				<el-button size="medium" type="primary" @click="allAllot">全部分配</el-button>
				<el-button size="medium" type="primary" @click="allCancel">全部取消</el-button>
			</div>
			<div class="topTable">
				<el-table border :data="leftTableData" ref="leftTable" style="width: 100%" max-height="250" @selection-change="handleSelectionChange1">
					<el-table-column align="center" fixed prop="loginname" label="用户名">
						<template slot-scope="scope">
							<i class="iconfont icon-touxiang" v-if="!scope.row.headurl" :class="{ 'Rank-one': index == 0, 'Rank-two': index == 1, 'Rank-three': index == 2 }"></i>
							<img v-else class="touxiang" :src="scope.row.headurl" alt="" />
							<span style="margin-top: 10px;">{{ scope.row.loginname }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="username" label="姓名"></el-table-column>
					<el-table-column align="center" prop="email" label="手机号"></el-table-column>
					<el-table-column align="center" prop="email" label="邮箱"></el-table-column>
					<el-table-column align="center" fixed="right" label="操作" width="240">
						<template slot-scope="scope">
							<el-link type="primary" :underline="false" @click="assignInterviewerUser(scope)">分配</el-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						background
						@size-change="leftHandleSizeChange"
						@current-change="leftHandleCurrentChange"
						:current-page="left_page.pageIndex"
						:page-sizes="[10, 50, 100, 200, 300, 400]"
						:page-size="left_page.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="left_page.total"
					></el-pagination>
				</div>
			</div>

			<div class="botTable">
				<el-table border :data="rightTableData" ref="rightTable" style="width: 100%" max-height="250" @selection-change="handleSelectionChange2">
					<el-table-column align="center" fixed prop="loginname" label="用户名">
						<template slot-scope="scope">
							<i class="iconfont icon-touxiang" v-if="!scope.row.headurl" :class="{ 'Rank-one': index == 0, 'Rank-two': index == 1, 'Rank-three': index == 2 }"></i>
							<img v-else class="touxiang" :src="scope.row.headurl" alt="" />
							{{ scope.row.loginname }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="username" label="姓名"></el-table-column>
					<el-table-column align="center" prop="email" label="手机号"></el-table-column>
					<el-table-column align="center" prop="email" label="邮箱"></el-table-column>
					<el-table-column align="center" fixed="right" label="操作" width="240">
						<template slot-scope="scope">
							<el-link type="primary" :underline="false" @click="unAssignInterviewerUser(scope)">取消分配</el-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="block">
					<el-pagination
						background
						@size-change="rightHandleSizeChange"
						@current-change="rightHandleCurrentChange"
						:current-page="right_page.pageIndex"
						:page-sizes="[10, 50, 100, 200, 300, 400]"
						:page-size="right_page.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="right_page.total"
					></el-pagination>
				</div>
			</div>
		</div>

		<el-dialog title="" :visible.sync="settingVisible" width="1400px" style="padding: 20px;" :close-on-click-modal="false" :show-close="false">
			<interviewerManagement></interviewerManagement>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="interviewerManagementOk">取 消</el-button>
				<el-button size="medium" type="primary" @click="interviewerManagementOk">确 定</el-button>
			</span>
		</el-dialog>
		
		<el-dialog title="" :visible.sync="dialConfiguration" width="1400px" style="padding: 20px;" :close-on-click-modal="false">
			<dialConfiguration></dialConfiguration>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialConfiguration = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="dialConfiguration = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import interviewerManagement from './interviewerManagement/index';
import dialConfiguration from './dialConfiguration/index';
import PageHeader from '@/components/pageHeader.vue';
export default {
	name: 'Interviewer',
	components: {
		interviewerManagement,
		dialConfiguration,
		PageHeader
	},
	data() {
		return {
			dialConfiguration:false,
			settingVisible:false,
			wj_id: '',
			left_page: {
				pageCount: 1,
				pageIndex: 1,
				pageSize: 10,
				total: 1
			},
			right_page: {
				pageCount: 1,
				pageIndex: 1,
				pageSize: 10,
				total: 1
			},
			radio: true,
			currentPage4: 1,

			leftTableData: [],
			rightTableData: [],
			touxiang: require('@/assets/default-imgs/touxiang.png'),
			leftTableSelection: [],
			rightTableSelection: [],

		};
	},
	computed: {
		selectIndex() {
			let state;
			if (this.$route.query.source == 'df') {
				state = 3;
			} else if (this.$route.query.source == 'mf') {
				state = 4;
			}
			return state;
		}
	},
	created() {
		this.wj_id = this.$route.query.id;
		this.loadInterviewerUserDatas();
		this.queryAssignInterviewUser();
	},
	mounted() {
		// this.loadInterviewerUserDatas();
		// this.queryAssignInterviewUser();
	},
	methods: {
		handleSelectionChange1(val) {
			this.leftTableSelection = val
		},
		handleSelectionChange2(val) {
			this.rightTableSelection = val
		},
		interviewerManagementOk(){
			this.loadInterviewerUserDatas();
			this.settingVisible = false
		},
		goDialConfiguration(){
			this.dialConfiguration=true
		},
		goSrtting() {
			this.settingVisible =true
		},
		// 全部分配
		allAllot() {
			let interviewerUserList = []
			if (this.leftTableSelection.length > 0) {
				this.leftTableSelection.forEach((info) => {
					interviewerUserList.push(info.id)
				})
			}
			let data = {
				interviewerUserList: interviewerUserList,
				questionnaireId: this.wj_id
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.allintervieweruserdistribution}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.$message.success(res.message);
						that.loadInterviewerUserDatas();
						that.queryAssignInterviewUser();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 全部取消
		allCancel() {
			let data = {
				interviewerUserList: [],
				questionnaireId: this.wj_id
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.allinterviewerusercanceldistribution}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.$message.success(res.message);
						that.loadInterviewerUserDatas();
						that.queryAssignInterviewUser();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 删除
		handleDelete(scope) {
			let ids = [scope.row.userId];
			this.$api
				.DelInterviewerUser(ids)
				.then(data => {
					if (data.code == 0) {
						this.$message({
							message: data.message,
							type: 'success'
						});
						this.loadInterviewerUserDatas();
						this.queryAssignInterviewUser();
					} else {
						this.$message.error(data.message);
					}
				})
				.catch(error => {
					this.$message.error(error.message);
				});
		},
		assignInterviewerUser(scope) {
			let data = {
				interviewerUserList: [scope.row.userId],
				questionnaireId: this.wj_id
			};
			this.$api
				.AssignInterviewUser(data)
				.then(data => {
					if (data.code == 0) {
						this.$message({
							message: data.message,
							type: 'success'
						});
						this.loadInterviewerUserDatas();
						this.queryAssignInterviewUser();
					} else {
						this.$message.error(data.message);
					}
				})
				.catch(error => {
					this.$message.error(error.message);
				});
		},
		unAssignInterviewerUser(scope) {
			console.log(scope);
			let data = {
				interviewerUserList: [scope.row.id]
				// questionnaireId: this.wj_id
			};
			this.$api
				.UnAssignInterviewUser(data)
				.then(data => {
					if (data.code == 0) {
						this.$message({
							message: data.message,
							type: 'success'
						});
						this.loadInterviewerUserDatas();
						this.queryAssignInterviewUser();
					} else {
						this.$message.error(data.message);
					}
				})
				.catch(error => {
					console.log(error);
					this.$message.error(error.message);
				});
		},
		leftHandleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.left_page.pageSize = val;
			this.loadInterviewerUserDatas();
		},
		leftHandleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.left_page.pageIndex = val;
			this.loadInterviewerUserDatas();
		},
		loadInterviewerUserDatas() {
			this.$api
				.InterviewerUserList(this.left_page.pageIndex, this.left_page.pageSize, '', this.wj_id)
				.then(data => {
					if (data.code == 0) {
						this.leftTableData = data.resultBody.datas;
						this.leftTableData.forEach(item => {
							item.headurl = item.headurl !='touxiang.png' ? item.headurl : this.touxiang
						});
						this.left_page.pageCount = data.resultBody.pageCount;
						this.left_page.pageIndex = data.resultBody.pageIndex;
						this.left_page.pageSize = data.resultBody.pageSize;
						this.left_page.total = data.resultBody.total;
						console.log('this.leftTableData',this.leftTableData)
					} else {
						this.leftTableData = [];
						this.left_page.pageCount = 1;
						this.left_page.pageIndex = 1;
						this.left_page.pageSize = 10;
						this.left_page.total = 0;
					}
				})
				.catch(error => {
					this.leftTableData = [];
					this.left_page.pageCount = 1;
					this.left_page.pageIndex = 1;
					this.left_page.pageSize = 10;
					this.left_page.total = 0;
				});
		},

		rightHandleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.right_page.pageSize = val;
			this.queryAssignInterviewUser();
		},
		rightHandleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.right_page.pageIndex = val;
			this.queryAssignInterviewUser();
		},
		queryAssignInterviewUser() {
			this.$api
				.QueryAssignInterviewUser(this.right_page.pageIndex, this.right_page.pageSize, this.wj_id)
				.then(data => {
					if (data.code == 0) {
						console.log(data.resultBody.datas);
						this.rightTableData = data.resultBody.datas;
						this.rightTableData.forEach(item => {
							item.headurl = item.headurl !='touxiang.png' ? item.headurl : this.touxiang
						});
						this.right_page.pageCount = data.resultBody.pageCount;
						this.right_page.pageIndex = data.resultBody.pageIndex;
						this.right_page.pageSize = data.resultBody.pageSize;
						this.right_page.total = data.resultBody.total;
					} else {
						this.rightTableData = [];
						this.right_page.pageCount = 1;
						this.right_page.pageIndex = 1;
						this.right_page.pageSize = 10;
						this.right_page.total = 0;
					}
				})
				.catch(error => {
					this.rightTableData = [];
					this.right_page.pageCount = 1;
					this.right_page.pageIndex = 1;
					this.right_page.pageSize = 10;
					this.right_page.total = 0;
				});
		},

		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style lang="scss" scoped>
.touxiang {
	width: 20px;
	height: 20px;
	margin-right: 10px;
	border-radius: 50%;
	object-fit: cover;
}
.details_header {
	// max-width: 1200px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;
	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}
	margin-bottom: 20px;
	cursor: pointer;
}
.interviewerBox {
	padding: 0 20px 20px 20px;
	.interviewer-set{
		text-align: right;
		margin-bottom: 10px;
	}
	.topTable {
		margin-bottom: 20px;
		.radioBtn {
			text-align: right;
			margin-top: 20px;
		}
		.block {
			text-align: right;
			margin-top: 20px;
		}
	}
	.botTable {
		.radioBtn {
			text-align: right;
			margin-top: 20px;
		}
		.block {
			text-align: right;
			margin-top: 20px;
		}
	}
	.subBtn {
		margin-top: 20px;
		text-align: center;
		.btn {
			width: 120px;
			height: 40px;
			font-size: 18px;
		}
	}
}
</style>
